module.exports = __webpack_public_path__ + "static/apple-touch-icon-152x152-c6376cdad3b225812a6a30e02ad0b6e2.png";